export const UTILITY_TYPES = {
  electric: 'Electric',
  gas: 'Gas',
  water: 'Water',
  propane: 'Propane',
  other: 'Other',
};

export const EMISSION_SCOPES = {
  electric: 'indirect',
  gas: 'direct',
  propane: 'direct',
};

export const addAccountTypes = [
  'electric',
  'gas',
  'propane',
  'water',
  'other',
  'production',
];

export const UTILITY_TYPES_OPTS = {
  0: 'Show all',
  1: 'Electric',
  2: 'Gas',
  3: 'Propane',
  4: 'Water',
  5: 'Other',
  6: 'Production',
};

export const SUB_TYPES =
{
  'water':
  {
    0: 'Potable - Indoor',
    1: 'Potable - Outdoor',
    2: 'Potable - Mixed',
    3: 'Reclaimed - Indoor',
    4: 'Reclaimed - Outdoor',
    5: 'Reclaimed - Mixed',
  },
  'other': {},
}


